export default function BrandsSection() {
  const brands = [
    { name: "Coforge", logo: "/images/coforge.png" },
    { name: "Cognizant", logo: "/images/cognizant.png" },
    { name: "HCLTech", logo: "/images/hcl.png" },
    { name: "Hexaware", logo: "/images/hexaware.png" },
    { name: "Infosys", logo: "/images/infosys.png" },
    { name: "Larsen & Toubro", logo: "/images/L&T.png" },
    { name: "LTIMindtree", logo: "/images/LTIMindtree.png" },
    { name: "Mphasis", logo: "/images/mphasis.png" },
    { name: "Persistent", logo: "/images/presistent.png" },
    { name: "Tata Elxsi", logo: "/images/tata.png" },
    { name: "TCS", logo: "/images/tcs.png" },
    { name: "Tech Mahindra", logo: "/images/techmahendra.png" },
    { name: "Wipro", logo: "/images/wipro.png" },
  ];
  const marqueeItems = [...brands, ...brands];
  return (
    <section className="brands-band">
      <div className="max-w-6xl mx-auto text-center px-4">
        <h2>
          Matching the <span>best brands</span> with the right expertise
        </h2>
        <div className="brands-band__logos">
          <div className="brands-marquee">
            {marqueeItems.map((brand, index) => (
              <div key={`${brand.name}-${index}`} className="brands-band__logo">
                <img src={brand.logo} alt={brand.name} />
              </div>
            ))}
          </div>
        </div>
        <p className="brands-band__cta">
          Creating a team? <a href="/contact-us">Contact our talent experts</a>
        </p>
      </div>
    </section>
  )
}

